<div class="ai-fixer-panel" [ngClass]="'state--' + panelState">

    <!-- ── IDLE: invite the user to start the AI fixer ─────────────────── -->
    <div class="ai-fixer-panel__idle" *ngIf="panelState === 'IDLE'">
        <div class="ai-fixer-panel__hero">
            <div class="ai-fixer-panel__hero-icon">
                <img src="assets/hamIcons/lightbulb.svg" alt="" />
            </div>
            <div class="ai-fixer-panel__hero-body">
                <div class="ai-fixer-panel__hero-titlerow">
                    <h3 class="ai-fixer-panel__title">{{ 'aumico_ai_fixer_panel_title' | i18next }}</h3>
                    <span class="ai-fixer-panel__beta-pill">{{ 'aumico_ai_fixer_panel_beta_label' | i18next }}</span>
                </div>
                <p class="ai-fixer-panel__description">
                    {{ 'aumico_ai_fixer_panel_description' | i18next }}
                </p>
                <ul class="ai-fixer-panel__bullets">
                    <li>{{ 'aumico_ai_fixer_panel_bullet_analyse' | i18next }}</li>
                    <li>{{ 'aumico_ai_fixer_panel_bullet_review' | i18next }}</li>
                    <li>{{ 'aumico_ai_fixer_panel_bullet_revert' | i18next }}</li>
                </ul>
                <div class="ai-fixer-panel__actions">
                    <ham-button
                        [disabled]="!jobRequest"
                        (buttonClick)="startJob()">
                        {{ 'aumico_ai_fixer_panel_start_btn' | i18next }}
                    </ham-button>
                </div>
            </div>
        </div>
    </div>

    <!-- ── RUNNING: spinner + live progress log ────────────────────────── -->
    <div class="ai-fixer-panel__running" *ngIf="panelState === 'RUNNING'">
        <div class="ai-fixer-panel__header">
            <span class="ai-fixer-panel__spinner"></span>
            <h3 class="ai-fixer-panel__title">{{ 'aumico_ai_fixer_panel_running_title' | i18next }}</h3>
            <ng-container *ngIf="(aiProvider.progressEvents$ | async) as events">
                <span class="ai-fixer-panel__steps" *ngIf="events.length > 0">
                    ({{ events.length }} {{ (events.length !== 1 ? 'aumico_ai_fixer_progress_steps' : 'aumico_ai_fixer_progress_step') | i18next }})
                </span>
            </ng-container>
        </div>
        <ai-fixer-progress
            [progressEvents]="(aiProvider.progressEvents$ | async) || []">
        </ai-fixer-progress>
    </div>

    <!-- ── COMPLETED: success + Accept / Reject ────────────────────────── -->
    <div class="ai-fixer-panel__completed" *ngIf="panelState === 'COMPLETED'">
        <div class="ai-fixer-panel__header">
            <img class="ai-fixer-panel__status-icon" src="assets/hamIcons/green-check-circle.svg" alt="" />
            <h3 class="ai-fixer-panel__title">{{ 'aumico_ai_fixer_panel_completed_title' | i18next }}</h3>
        </div>

        <!-- Domain-specific result projected here -->
        <div class="ai-fixer-panel__result">
            <ng-content select="[ai-result]"></ng-content>
        </div>

        <div class="ai-fixer-panel__actions">
            <!-- Caller can project extra action buttons (e.g. Preview) here -->
            <ng-content select="[ai-actions]"></ng-content>
            <ham-button (buttonClick)="acceptResult()">
                {{ 'aumico_ai_fixer_panel_accept_btn' | i18next }}
            </ham-button>
            <ham-button outline="true" (buttonClick)="rejectResult()">
                {{ 'aumico_ai_fixer_panel_reject_btn' | i18next }}
            </ham-button>
        </div>
    </div>

    <!-- ── FAILED: error + Retry / Cancel ──────────────────────────────── -->
    <div class="ai-fixer-panel__failed" *ngIf="panelState === 'FAILED'">
        <div class="ai-fixer-panel__header">
            <img class="ai-fixer-panel__status-icon" src="assets/hamIcons/x-circle-red.svg" alt="" />
            <h3 class="ai-fixer-panel__title">{{ 'aumico_ai_fixer_panel_failed_title' | i18next }}</h3>
        </div>
        <p class="ai-fixer-panel__error">
            {{ (error?.messageKey || 'aumico_ai_fixer_panel_unknown_error') | i18next: (error?.params || {}) }}
        </p>
        <div class="ai-fixer-panel__actions">
            <ham-button (buttonClick)="retry()">
                {{ 'aumico_ai_fixer_panel_retry_btn' | i18next }}
            </ham-button>
            <ham-button outline="true" (buttonClick)="rejectResult()">
                {{ 'aumico_ai_fixer_panel_cancel_btn' | i18next }}
            </ham-button>
        </div>
    </div>
</div>
